"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clickable = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const create_styles_1 = require("../utils/create-styles");
exports.Clickable = (0, styled_1.default)('button', {
    shouldForwardProp: (prop) => prop !== 'styles' && prop !== 'hoverBackgroundColor',
})((props) => {
    return {
        // Reset styles to a plain div
        all: 'unset',
        display: 'block',
        width: '100%',
        boxSizing: 'border-box',
        // Cursor
        cursor: 'pointer',
        '&:disabled': {
            cursor: 'not-allowed',
        },
        ...(props.hoverBackgroundColor && {
            '&:hover': {
                backgroundColor: props.hoverBackgroundColor,
            },
        }),
        ...(0, create_styles_1.createStyles)(props.styles),
    };
});
